/**
 * Whether a nav link is active, given the matched route paths from
 * `useMatches().map((m) => m.fullPath)` (ordered root → leaf).
 *
 * `exact` links (e.g. Home `/`) match only when the target IS the current
 * page — the leaf match. The always-present root route's `fullPath` is `/`,
 * so comparing against the whole chain would light up Home on every route
 * (RRP-0039). Non-exact links match when any matched segment is the target or
 * a child of it — matching on a segment boundary, so `/mcp` doesn't light up
 * for the unrelated sibling `/mcp-instructions`, while a parent link still
 * stays lit on its child routes.
 */
export function isNavLinkActive(
  matchedPaths: readonly string[],
  to: string,
  exact = false,
): boolean {
  if (exact) return matchedPaths.at(-1) === to
  return matchedPaths.some((path) => path === to || path.startsWith(`${to}/`))
}
